module.exports = __webpack_public_path__ + "img/RCloudMachines.8a85a23f.png";